import React from 'react';
import StarSymbol from './StarSymbol';
import { StarRatingProps } from './types';

const StarRating = ({ rating }: StarRatingProps) => {
  const starSymbol = '\u2605';
  const starComponents = [];
  const completeStars = Math.floor(rating);
  const partialStargreenPercentage = rating % 1;

  for (let i = 0; i < completeStars; i++) {
    starComponents.push(
      <StarSymbol
        key={i}
        greenPercentage={100}
      />
    );
  }
  starComponents.push(
    <StarSymbol
      key={completeStars}
      greenPercentage={partialStargreenPercentage * 100}
    />
  );
  for (let i = completeStars + 1; i < 5; i++) {
    starComponents.push(
      <div
        style={{ color: 'black', display: 'inline-block', fontSize: '24px' }}
      >
        {starSymbol}
      </div>
    );
  }

  return <div style={{ display: 'inline-block' }}>{starComponents}</div>;
};

export default StarRating;
